import React, { useEffect } from "react";

import { useAuth } from "@/auth/auth.ts";

/**
 * Restores the session from the stored refresh token, once, on mount.
 * Renders nothing: LoginBouncer reads the resulting status.
 */
export const InitAuth: React.FC = () => {
  const auth = useAuth();
  const status = auth.status;

  useEffect(() => {
    if (status === "pending") {
      // restoreSession never rejects: it settles on 'unauthenticated' instead.
      void auth.restoreSession();
    }
    // `status` only: useMutation returns a fresh object every render, so
    // `restoreSession`'s identity churns and depending on it would loop forever.
  }, [status]);

  return null;
};
